import { SITE_URL, SITE_NAME, FAVICON_URL } from "./site";

function upsertJsonLd(id: string, data: unknown): void {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement("script");
    el.setAttribute("type", "application/ld+json");
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

function removeJsonLd(id: string): void {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export function injectHomeSchema(description: string): void {
  const website = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    description,
    inLanguage: "en",
  };

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: `${SITE_URL}/`,
    logo: FAVICON_URL,
  };

  upsertJsonLd("seo-website", website);
  upsertJsonLd("seo-organization", organization);
  removeJsonLd("seo-article");
}

export interface ArticleSchemaData {
  title: string;
  description: string;
  image?: string;
  slug: string;
  dateModified: string;
}

export function injectArticleSchema(data: ArticleSchemaData): void {
  const publisher = {
    "@type": "Organization",
    name: SITE_NAME,
    logo: {
      "@type": "ImageObject",
      url: FAVICON_URL,
    },
  };

  const article: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: data.title,
    description: data.description,
    dateModified: data.dateModified,
    mainEntityOfPage: `${SITE_URL}/guide/${data.slug}`,
    author: { "@type": "Organization", name: SITE_NAME },
    publisher,
    inLanguage: "en",
  };

  if (data.image) {
    article.image = data.image;
  }

  upsertJsonLd("seo-article", article);
  removeJsonLd("seo-website");
  removeJsonLd("seo-organization");
}

export function removeAllSchema(): void {
  removeJsonLd("seo-website");
  removeJsonLd("seo-organization");
  removeJsonLd("seo-article");
}